import { tabs } from '../../../../../../views/dashboard/company/CompanyDashboard';

export default {
  title: 'Dashboard',
  tabs: {
    [tabs.general]: 'General',
    [tabs.overview]: 'Prezentare generală',
    [tabs.orders]: 'Comenzi pe sursă',
    [tabs.google]: 'Google',
    [tabs.customers]: 'Clienți',
    [tabs.order_conversion]: 'Conversie comenzi',
    [tabs.mobile_app]: 'Aplicație mobilă',
  },
  date_range: {
    this_month: 'Luna aceasta',
    last_month: 'Luna trecută',
    last_week: 'Săptămâna trecută',
    this_week: 'Săptămâna aceasta',
    this_year: 'Anul acesta',
    last_year: 'Anul trecut',
    today: 'Astăzi',
    yesterday: 'Ieri',
    all: 'Toate',
  },
  buttons: {
    view_key_info: 'Vezi informații cheie',
  },
  empty_franchise: {
    description: 'Acest brand nu are încă niciun restaurant. Alege alt brand din meniu pentru a vedea cifrele.',
  },
};
